/**
 * Core – Main menu (shared across all projects)
 */

export default {
  menu: {
    home: "Home",
    stores: "Stores",
    transactions: "Transactions",
    vatRet: "VAT",
    taxSettings: "Settings",
    vatReg: "VAT Registration",
    taxAudit: "Tax Audit",
    taxAcademy: "Tax Academy",
    invite: "Invite & earn 15€",
    support: "Support",
    billing: "Billing",
    logOut: "Log out",
    dashboard: "Dashboard",
    salesTax: "Sales TAX",
    eprReporting: "EPR",
    packagingSku: "Packaging SKU",
    startGuide: "Start guide",
    products: "Products",
    packaging: "Packaging",
    reports: "Reports",
    reportCalendar: "Report Calendar",
    messages: "Messages",
    helpCenter: "Help center",
    clients: "Clients",
    otherLovatApps: "Other Lappa Apps",
    selectLovatApp: "Select a Lappa App",
    globalSettingsTooltip: "Global settings",
    changeCompanyTooltip: "Change company",
    notificationCenterTooltip: "Notification center",
    switchingApp: "Switching app...",
    switchingAppLabel: "Switching app",
    manageApplications: "Manage L'Applications",
    sessionExpiredLoginAgain: "Session expired or unauthorized. Please log in again.",
    failedToSwitchApp: "Failed to switch app. Please try again.",
    selectCompany: "Please select the company to view and edit the data:",
    selectClient: "Please select client:",
    active: "Active",
    trial: "Trial",
    selectValidApp: "Please select a valid Lappa App to continue.",
    projectPickerTitle: "Select a Lappa App to Begin",
    projectPickerSubtitle: "Get started on Lappa apps. No worries, you can always add another app.",
    projectPickerLoadingLabel: "Loading apps",
    projectPickerLoading: "Loading your apps...",
    continueButton: "Continue",
    workspaceAccessErrorTitle: "Can't open this workspace",
    switchBackToLive: "Switch back to live company",
    switchBackToLiveFailed: "Failed to switch back to the live company.",
    userFallback: "User",
    appDescLTax: "VAT Registration・VAT Calculation・VAT reporting・VAT payment・Sales tax registration・Sales tax calculation・Sales tax reporting・Sales tax payment",
    appDescLEPR: "EPR Registration & Reporting",
    appDescLInvoice: "Send & Receive Peppol Invoices",
    appDescLAuthorize: "CE marking・UKCA marking・GSPR label・Authorized representative services for import",
  },
};
